import React, { useEffect, useState } from "react"
import GridContainer from "../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../components/layouts/containers/GridItem.container"
import Divider from "../../../components/atoms/Divider.atom"
import InputTextForm from "../../../components/molecules/InputTextForm.molecule"
import { InputCheckboxForm } from "../../../components/molecules/InputCheckboxForm.molecule"
import { VacationDaysDatePicker } from "./VacationDaysDatePicker.molecule"
import { VacationDaysRadioButton } from "./VacationDaysRadioButton.molecule"
import { VacationSingleDayToUse } from "./VacationSingleDayToUse.molecule"
import { VacationDaysCounter } from "./VacationDaysCounter.molecule"
import VacationBucketDaysTable from "./VacationBucketDays/VacationBucketDaysTable.molecule"
import { UNIFIEDDATE_VALUES } from "../../../consts/CompoundRangeDatePicker"
import { MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE } from "../../../consts/modules/vacations.consts"
import { validateFieldValue } from "../../../utils/validations.utils"
import { compareDates, isDateAtWeekend } from "../../../utils/date.utils"
import { DateTime } from "luxon"
import MessageRect from "../../../components/atoms/MessageRect.atom"
import {
  availableSingleDays,
  isMexicanSchema,
} from "../../../utils/vacation.utils"
import { VACATION_REQUEST_FORM_MODE } from "../../../hooks/useMyVacationRequestFormState.hook"
import FieldContainer from "../../../components/layouts/containers/FieldContainer.container"
import BlockUI from "../../../components/atoms/misc/BlockUI.atom"
import IconWithTooltip from "../../../components/molecules/IconWithTooltip.molecule"
import { Accordion } from "../../../components/atoms/Accordion.atom"
import { AccordionTab } from "primereact/accordion"

const VacationCreateRequestSummary = ({
  multipleDays,
  setMultipleDays,
  daysToUse,
  typesOfDaysToUse,
  isApprovedChangeRequest = false,
  maxStartDate,
  maxDate,
  vacationRequestValues,
  setVacationRequestValues,
  vacationRequestValidation,
  setVacationsRequestValidation,
  selectedPeriod,
  availableDaysList,
  disabledDayList,
  reminderTitle,
  reminderBody,
  holidaySchemaId,
  bucketDaysList,
  vacationFormMode = VACATION_REQUEST_FORM_MODE.CREATE,
  disabled = false,
  anniversaryDate,
}) => {
  const today = DateTime.now().set({
    hour: 12,
    millisecond: 0,
    minute: 0,
    second: 0,
  })
  const validStartDate = vacationRequestValues.requestDates[0]
  const threeMonthsFromNow = today.plus({ months: 3 })

  const [
    bucketDaysTableCenterHighlightedMonth,
    setBucketDaysTableCenterHighlightedMonth,
  ] = useState(false)

  const getMaxVacationDate = (anniversaryDate) => {
    const today = DateTime.now();
    const anniversary = DateTime.fromISO(anniversaryDate);


    let nextAnniversary = anniversary.set({ year: today.year });
    if (nextAnniversary < today) {
      nextAnniversary = nextAnniversary.plus({ years: 1 });
    }

    const lastDayNextAnniversary = nextAnniversary.plus({ years: 1 }).minus({ days: 1 });
    return lastDayNextAnniversary;
};

  return (
    <BlockUI className="vacation-create-request__block-ui" blocked={disabled}>
      <GridContainer className="vacation-create-request">
        <GridItem col={12} md={6} className="col-top-data">
          <VacationDaysDatePicker
            label="Fecha inicial"
            dateRange={[validStartDate, validStartDate]}
            setDateRange={(e) => {
              setVacationRequestValues({
                ...vacationRequestValues,
                requestDates: [e[0], e[0]],
              })
            }}
            period={UNIFIEDDATE_VALUES.SINGLEDAY}
            datePickerProps={{
              minDate: MY_VACATION_MODULE_DEPLOY_REQUEST_SUMMARY_DATE,
              maxDate: getMaxVacationDate(anniversaryDate),
              className: "w-full max-w-full",
              disabledDate: (current) => {
                return (
                  disabledDayList.some(
                    (h) => h.date && compareDates(h.date, current)
                  ) || isDateAtWeekend(current)
                )
              },
            }}
          />
        </GridItem>
        <GridItem col={12} md={6} className="col-top-data">
          {multipleDays ?
            <VacationDaysDatePicker
              label="Fecha final"
              dateRange={[
                validStartDate > vacationRequestValues.requestDates[1] ?
                  validStartDate
                : vacationRequestValues.requestDates[1],
                validStartDate > vacationRequestValues.requestDates[1] ?
                  validStartDate
                : vacationRequestValues.requestDates[1],
              ]}
              setDateRange={(e) => {
                setVacationRequestValues({
                  ...vacationRequestValues,
                  requestDates: [vacationRequestValues.requestDates[0], e[0]],
                })
              }}
              period={UNIFIEDDATE_VALUES.SINGLEDAY}
              datePickerProps={{
                minDate: validStartDate,
                maxDate: DateTime.min(
                  maxDate, 
                  getMaxVacationDate(anniversaryDate)
                ),
                className: "w-full max-w-full",
                disabledDate: (current) => {
                  return (
                    disabledDayList.some(
                      (h) => h.date && compareDates(h.date, current)
                    ) || isDateAtWeekend(current)
                  )
                },
              }}
            />
          : null}
        </GridItem>
        <GridItem col={12} className="col-checkbox">
          <InputCheckboxForm
            checked={multipleDays}
            onChange={(e) => {
              setMultipleDays(e.checked)
              setVacationRequestValues({
                ...vacationRequestValues,
                requestDates: [
                  vacationRequestValues.requestDates[0],
                  vacationRequestValues.requestDates[0],
                ],
              })
            }}
            label="Varios días"
          />
        </GridItem>
        <GridItem col={12} className="days-counter">
          <div className="vacation-days-to-take">
            <label className="vacation-days-to-take__label">
              Días por tomar
            </label>
            <div className="vacation-days-to-take__single-day-counter">
              <label className="vacation-days-to-take__value">
                {daysToUse}
              </label>
              {typesOfDaysToUse === 1 ?
                <VacationSingleDayToUse availableDaysList={availableDaysList} />
              : null}
            </div>
            {typesOfDaysToUse === 1 ?
              <label
                className={`vacation-days-to-take__counter ${availableSingleDays(availableDaysList, vacationRequestValues) < 0 ? "vacation-days-to-take__counter--error" : ""}`}
              >
                Disponibles:{" "}
                {availableSingleDays(availableDaysList, vacationRequestValues)}
              </label>
            : null}
          </div>
        </GridItem>
        {daysToUse === 1 && typesOfDaysToUse > 1 ?
          <>
            <GridItem col={12} className="vacation-radio-button-label">
              <label>Tipo de día</label>
            </GridItem>
            <GridItem col={12} className="vacation-radio-button">
              {(
                availableDaysList.bucketDays !== null &&
                availableDaysList.bucketDays > -3
              ) ?
                <VacationDaysRadioButton
                  label="Cubeta"
                  usedDays={vacationRequestValues.bucketDays}
                  onChangeUsedDays={() => {
                    setVacationRequestValues({
                      ...vacationRequestValues,
                      bucketDays: 1,
                      plusDays: 0,
                      accordedDays: 0,
                      additionalDays: 0,
                    })
                  }}
                  availableDays={
                    availableDaysList.bucketDays -
                    vacationRequestValues.bucketDays
                  }
                />
              : null}
              {(
                availableDaysList.plusDays != null &&
                availableDaysList.plusDays > 0
              ) ?
                <VacationDaysRadioButton
                  label="Día +"
                  usedDays={vacationRequestValues.plusDays}
                  onChangeUsedDays={() => {
                    setVacationRequestValues({
                      ...vacationRequestValues,
                      bucketDays: 0,
                      plusDays: 1,
                      accordedDays: 0,
                      additionalDays: 0,
                    })
                  }}
                  availableDays={
                    availableDaysList.plusDays - vacationRequestValues.plusDays
                  }
                />
              : null}
              {(
                availableDaysList.accordedDays != null &&
                availableDaysList.accordedDays > 0
              ) ?
                <VacationDaysRadioButton
                  label="Regular"
                  usedDays={vacationRequestValues.accordedDays}
                  onChangeUsedDays={() => {
                    setVacationRequestValues({
                      ...vacationRequestValues,
                      bucketDays: 0,
                      plusDays: 0,
                      accordedDays: 1,
                      additionalDays: 0,
                    })
                  }}
                  availableDays={
                    availableDaysList.accordedDays -
                    vacationRequestValues.accordedDays
                  }
                />
              : null}
              {(
                availableDaysList.additionalDays !== null &&
                availableDaysList.additionalDays > 0
              ) ?
                <VacationDaysRadioButton
                  label="Adicional"
                  usedDays={vacationRequestValues.additionalDays}
                  onChangeUsedDays={() => {
                    setVacationRequestValues({
                      ...vacationRequestValues,
                      bucketDays: 0,
                      plusDays: 0,
                      accordedDays: 0,
                      additionalDays: 1,
                    })
                  }}
                  availableDays={
                    availableDaysList.additionalDays -
                    vacationRequestValues.additionalDays
                  }
                />
              : null}
            </GridItem>
          </>
        : null}
        {daysToUse > 1 && typesOfDaysToUse > 1 ?
          <GridItem col={12} className="vacation-counter">
            {(
              availableDaysList.bucketDays != null &&
              availableDaysList.bucketDays > -3
            ) ?
            <>
              <VacationDaysCounter
                label="Cubeta"
                usedDays={vacationRequestValues.bucketDays}
                onChangeUsedDays={(e) => {
                  setVacationRequestValues({
                    ...vacationRequestValues,
                    bucketDays: e.value,
                  })
                }}
                availableDays={
                  availableDaysList.bucketDays -
                  vacationRequestValues.bucketDays
                }
                maxDaysToUse={
                  (
                    availableDaysList.bucketDays + 3 >
                    daysToUse -
                      vacationRequestValues.plusDays -
                      vacationRequestValues.accordedDays -
                      vacationRequestValues.additionalDays
                  ) ?
                    daysToUse -
                    vacationRequestValues.plusDays -
                    vacationRequestValues.accordedDays -
                    vacationRequestValues.additionalDays
                  : availableDaysList.bucketDays + 3
                }
              />
    
            </>  
            : null}
            {(
              availableDaysList.plusDays != null &&
              availableDaysList.plusDays > 0
            ) ?
              <VacationDaysCounter
                label="Día +"
                usedDays={vacationRequestValues.plusDays}
                onChangeUsedDays={(e) => {
                  setVacationRequestValues({
                    ...vacationRequestValues,
                    plusDays: e.value,
                  })
                }}
                availableDays={
                  availableDaysList.plusDays - vacationRequestValues.plusDays
                }
                maxDaysToUse={
                  (
                    availableDaysList.plusDays >
                    daysToUse -
                      vacationRequestValues.bucketDays -
                      vacationRequestValues.accordedDays -
                      vacationRequestValues.additionalDays
                  ) ?
                    daysToUse -
                    vacationRequestValues.bucketDays -
                    vacationRequestValues.accordedDays -
                    vacationRequestValues.additionalDays
                  : availableDaysList.plusDays
                }
              />
            : null}
            {(
              availableDaysList.accordedDays !== null &&
              availableDaysList.accordedDays > 0
            ) ?
              <VacationDaysCounter
                label="Regular"
                usedDays={vacationRequestValues.accordedDays}
                onChangeUsedDays={(e) => {
                  setVacationRequestValues({
                    ...vacationRequestValues,
                    accordedDays: e.value,
                  })
                }}
                availableDays={
                  availableDaysList.accordedDays -
                  vacationRequestValues.accordedDays
                }
                maxDaysToUse={
                  (
                    availableDaysList.accordedDays >
                    daysToUse -
                      vacationRequestValues.bucketDays -
                      vacationRequestValues.plusDays -
                      vacationRequestValues.additionalDays
                  ) ?
                    daysToUse -
                    vacationRequestValues.bucketDays -
                    vacationRequestValues.plusDays -
                    vacationRequestValues.additionalDays
                  : availableDaysList.accordedDays
                }
              />
            : null}
            {(
              availableDaysList.additionalDays !== null &&
              availableDaysList.additionalDays > 0
            ) ?
              <VacationDaysCounter
                label="Adicional"
                usedDays={vacationRequestValues.additionalDays}
                onChangeUsedDays={(e) => {
                  setVacationRequestValues({
                    ...vacationRequestValues,
                    additionalDays: e.value,
                  })
                }}
                availableDays={
                  availableDaysList.additionalDays -
                  vacationRequestValues.additionalDays
                }
                maxDaysToUse={
                  (
                    availableDaysList.additionalDays >
                    daysToUse -
                      vacationRequestValues.bucketDays -
                      vacationRequestValues.plusDays -
                      vacationRequestValues.accordedDays
                  ) ?
                    daysToUse -
                    vacationRequestValues.bucketDays -
                    vacationRequestValues.plusDays -
                    vacationRequestValues.accordedDays
                  : availableDaysList.additionalDays
                }
              />
            : null}
          </GridItem>
        : null}
        {(
          vacationRequestValues.requestDates[0] <= threeMonthsFromNow &&
          vacationRequestValues.plusDays > 0
        ) ?
          <GridItem col={12}>
            <MessageRect
              severity="warn"
              icon="pi-exclamation-triangle"
              className="vacation-reminder"
            >
              Recuerda que los Días + se piden con al menos 3 meses de
              anticipación. Esta solicitud no cumple con el tiempo requerido.
            </MessageRect>
          </GridItem>
        : null}
        {(
          holidaySchemaId !== null &&
          isMexicanSchema(holidaySchemaId) &&
          bucketDaysList !== null
        ) ?
          <GridItem col={12}>
            <Accordion
              className="bucket-days-info-accordion"
              onTabOpen={() =>
                setBucketDaysTableCenterHighlightedMonth((prev) => !prev)
              }
            >
              <AccordionTab header={"Ver resumen de cubeta"}>
                <VacationBucketDaysTable
                  bucketDaysInfo={bucketDaysList}
                  monthToHighlight={Number(
                    vacationRequestValues.requestDates[1]
                      .startOf("month")
                      .diff(selectedPeriod[0].startOf("month"), "months")
                      .toObject().months
                  )}
                  centerHighlightedMonth={bucketDaysTableCenterHighlightedMonth}
                  anniversaryDate={anniversaryDate}
                />
              </AccordionTab>
            </Accordion>
          </GridItem>
        : null}
        <Divider stroke="sm" />
        <FieldContainer col={12} md={12} className="my-0 pt-0">
          <InputTextForm
            label="Motivo"
            value={vacationRequestValues.motive}
            onChange={(e) => {
              setVacationRequestValues({
                ...vacationRequestValues,
                motive: e.target.value,
              })
              setVacationsRequestValidation(
                validateFieldValue(
                  vacationRequestValidation,
                  "motive",
                  e.target.value
                )
              )
            }}
            error={vacationRequestValidation.motive.errors}
          />
        </FieldContainer>
        {isApprovedChangeRequest ?
          <FieldContainer col={12} md={12} className="my-0">
            <InputTextForm
              label="Razón del cambio"
              value={vacationRequestValues.changeMotive}
              onChange={(e) => {
                setVacationRequestValues({
                  ...vacationRequestValues,
                  changeMotive: e.target.value,
                })
                setVacationsRequestValidation(
                  validateFieldValue(
                    vacationRequestValidation,
                    "changeMotive",
                    e.target.value
                  )
                )
              }}
              error={vacationRequestValidation.changeMotive.errors}
            />
          </FieldContainer>
        : null}
        <GridItem col={12} className="mt-2 mb-0 pb-1">
          {reminderTitle && reminderBody && (
            <MessageRect className="vacation-reminder" title={reminderTitle}>
              {reminderBody}
            </MessageRect>
          )}
        </GridItem>
      </GridContainer>
    </BlockUI>
  )
}

export default VacationCreateRequestSummary
